import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';

import { KpiStatistics, ExpenseStatistics, UserStatistics } from 'features/Statistics/pages';
// import { ReviseProjectProposalDetail } from 'features/ReviseProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';

function StatisticsPage() {
  const { t } = useTranslation();
  // const { state } = useLocation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 0;

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <TabView
            activeIndex={parseInt(tab, 10)}
            onTabChange={(e) => navigate(`.?tab=${e.index}`)}
          >
            {ability.can('read', 'statistic_detail') && (
              <TabPanel header={t('statistic.userStatistic')} leftIcon="pi pi-list mr-2">
                <UserStatistics />
              </TabPanel>
            )}
            {ability.can('read', 'statistic_detail') && (
              <TabPanel header={t('researchKpiGroup.viewList.header')} leftIcon="pi pi-list mr-2">
                <KpiStatistics />
              </TabPanel>
            )}
            {ability.can('read', 'statistic_detail') && (
              <TabPanel header={t('statistic.header')} leftIcon="pi pi-list mr-2">
                <ExpenseStatistics />
              </TabPanel>
            )}
            {ability.cannot('read', 'statistic_detail') && (
              <h4 className="text-red-500">{t('permission.forbid.read.statisticDetail')}</h4>
            )}
          </TabView>
          <ScrollTop target="parent" />
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default StatisticsPage;
